import { create } from "domain";
import { createContext } from "react";

export const sliceBanner=createContext<any>(null);
